import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ConciergeState } from './concierge.reducers'
import { featureConciergeName } from './concierge.state'

export const getConciergeFeatureState = createFeatureSelector<ConciergeState>(featureConciergeName)

export const getConciergeUser = createSelector(getConciergeFeatureState, state => state.conciergeUser)
